import { render, staticRenderFns } from "./TransportOrders.vue?vue&type=template&id=129ba208"
import script from "./TransportOrders.vue?vue&type=script&lang=js"
export * from "./TransportOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports